import { Chart } from "chart.js";

export default {
	enabled: false, // Disable the on-canvas tooltip (in favor of below `external` implementation)
	displayColors: false,

	callbacks: {
		title: function (dataPoints) {
			const firstDataSet = dataPoints[0].dataset;

			function percentIcon(percentChange) {
				if (percentChange != 0) {
					return `<span class='glyphicon glyphicon-arrow-${percentChange > 0 ? "up" : "down"}'></span>`;
				} else {
					return "";
				}
			}
			if (firstDataSet.percentage_changes) {
				const percentChange =
					firstDataSet.percentage_changes[dataPoints[0].dataIndex];
				if (percentChange != 0) {
					return [
						{
							lines: [
								percentChange.toFixed(2) + "%" + percentIcon(percentChange),
							],
						},
					];
				} else {
					return null;
				}
			} else {
				return null;
			}
		},

		label: function (datasetForIndex) {
			// This will either be just a number or an object à la `{x: theXaxisPos, y: theNumber}`
			// The object version is only used to accomodate the line chart in game_series/show
			let dataForItem = datasetForIndex.dataset.data[datasetForIndex.dataIndex];
			// pp.log("into label", datasetForIndex, dataForItem);
			if (dataForItem !== undefined) {
				if (typeof dataForItem === "object") {
					dataForItem = dataForItem.y;
				}

				// For the case where the dataset consists of hashes
				let toReturn = "";
				if (datasetForIndex.label) {
					toReturn += datasetForIndex.label + ", "; // The name of the category
				}

				if (datasetForIndex.dataset.label) {
					toReturn += datasetForIndex.dataset.label + ": ";
				} else if (
					datasetForIndex.dataset.labels &&
					datasetForIndex.dataset.labels[datasetForIndex.dataIndex]
				) {
					toReturn +=
						datasetForIndex.dataset.labels[datasetForIndex.dataIndex] + ": ";
				}
				const number = window.numeral(dataForItem.toString());
				const formattedValue = number.format(
					// @ts-expect-error
					Math.abs(number) >= 10000 ? window.numeral.formatWithUnit : "",
				);
				toReturn += formattedValue;
				if (datasetForIndex.dataset.value_unit) {
					toReturn += " " + datasetForIndex.dataset.value_unit;
				}
				return toReturn;
			}
			// else
			return null;
		},
	},

	external: function (context) {
		const tooltipModel = context.tooltip;
		// Tooltip Element
		let tooltipEl = document.getElementById("chartjs-tooltip");

		// Create element on first render
		if (!tooltipEl) {
			tooltipEl = document.createElement("div");
			tooltipEl.id = "chartjs-tooltip";
			tooltipEl.innerHTML = '<div class="Chart__tooltip"><div>';
			document.body.appendChild(tooltipEl);
		}

		// Hide if no tooltip
		if (tooltipModel.opacity === 0) {
			// @ts-expect-error
			tooltipEl.style.opacity = 0;
			return;
		}

		// Set caret Position
		tooltipEl.classList.remove("above", "below", "no-transform");
		tooltipEl.classList.add(
			tooltipModel.yAlign ? tooltipModel.yAlign : "no-transform",
		);

		let html = "";

		// Set Text
		if (tooltipModel.body) {
			const bodyLines = tooltipModel.body.map((bodyItem) => {
				return bodyItem.lines;
			});

			bodyLines.forEach(function (body, i) {
				html += `<div class="Chart__tooltip_part Chart__tooltip_part-0"><span>${body}</span></div>`;
			});
		}
		if (tooltipModel.title) {
			const titleLines = tooltipModel.title || [];
			titleLines.forEach(function (title, i) {
				html += `<div class="Chart__tooltip_part Chart__tooltip_part-1"><span>${title.lines[0]}</span></div>`;
			});
		}

		const tooltipWrapper = tooltipEl.querySelector(".Chart__tooltip");
		// @ts-expect-error
		tooltipWrapper.innerHTML = html;

		// `this` will be the overall tooltip
		const position = context.chart.canvas.getBoundingClientRect();
		// @ts-expect-error
		const bodyFont = Chart.helpers.toFont(tooltipModel.options.bodyFont);

		// Display, position, and set styles for font
		// @ts-expect-error
		tooltipEl.style.opacity = 1;
		tooltipEl.style.position = "absolute";
		tooltipEl.style.left =
			position.left + window.pageXOffset + tooltipModel.caretX + "px";
		tooltipEl.style.top =
			position.top + window.pageYOffset + tooltipModel.caretY + "px";
		tooltipEl.style.font = bodyFont.string;
		tooltipEl.style.padding =
			tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
		tooltipEl.style.pointerEvents = "none";
	},
};
